var Backbone = require('backbone');
var _ = require('lodash');
var template = require('../templates/user.ejs');

'use strict';

module.exports = Backbone.View.extend({
    className: 'view-user',
    events: {
        'click .logout' : 'logout'
    },
        
    initialize: function (options) {
        _.bindAll(this, 'render');
        
        this.cms = options.cms;
        this.auth = options.auth;

        this.listenTo(this.auth, 'change:userName', _.bind(this.render, this));
        this.listenTo(this.auth, 'change:isAuthorized', _.bind(this.render, this));
        this.listenTo(this.cms, 'change:windowStatus', _.bind(this.render, this));
    },
    
    render: function () {
        
        var username = this.auth.get('userName');
        var user = null;
        var welcome = null;
        var hello = null;
        if(this.auth.get('userName')){
            user = username.length > 31 ? this.auth.get('userName').substr(0, 31) + '...' : this.auth.get('userName');
            welcome = this.cms.get('text')['views_login'].welcome_copy;
            hello = welcome.replace('{user}','<span class="username">'+user+'</span>');
        }
        var copy = {
            welcome_copy: hello,
            login: this.cms.get('text')['views_login'].login_cta_copy,
            logout: this.cms.get('text')['views_login'].logout_copy
        };
        console.log('LOGIN',copy);
        this.$el.html(template({
            user: user,
            copy: copy,
            window: this.cms.get('windowStatus')
        }));
        
        return this;
    },
    
    logout: function (e) {
        console.log('logout', e);
        e.preventDefault();
        this.auth.deAuthorize();
        
        var evt = {
            target: this
        };

        this.trigger('clearUser',evt);
        evt.name = 'eventClickLogout';
        evt.origEvent = e;
        this.trigger('trackEvent',evt);
    }
    
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/user.js
// module id = 98
// module chunks = 0